import Breadcrumb from '@/components/common/breadcrumb';
import { NoAccess } from '@/components/common/noaccess';
import { People } from '@/components/people/people';
import { usePerson } from '@/components/people/people/hooks';
import Profile from '@/components/people/people/profile';
import ProfileAvatarCard from '@/components/people/people/profileAvatarCard';
import CardContainer from '@/components/people/people/profileCard';
import ProfileTabs from '@/components/people/people/profileTabs';
import { useUserAccess } from '@/hooks/auth';
import { useMyPeopleAccess } from '@/store/access/access';
import { useParams } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { useState, useEffect } from 'react';

export default function ProfileCard() {
  const { id } = useParams();
  const access = useUserAccess();
  const peopleAccess = useMyPeopleAccess({});
  const structureAccess = peopleAccess.access.structure_view === 'allow';
  const { loading, person } = usePerson(id || '');

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setError('No ID provided');
    }
  }, [id]);

  const profile = person || null;

  console.log('plop profile', profile);

  if (!access?.people && !access?.admin) {
    return <NoAccess />;
  }

  if (!access?.admin && !structureAccess) {
    return <People />;
  } // TODO access control for structure admin

  const items = [
    { label: 'Dashboard', href: '/' },
    { label: 'People', href: '/people' },
    { label: 'Member Profile', href: '/people/profileCard' },
  ];

  const tabs = [
    {
      id: 'profile',
      label: 'Profile',
      content: <Profile title='Profile' />,
    },
    {
      id: 'comments',
      label: 'Comments',
      content: <Profile title='Comments' />,
    },
    {
      id: 'teams',
      label: 'Teams',
      content: <Profile title='Teams' />,
    },
    {
      id: 'followup',
      label: 'Follow Up Tasks',
      content: <Profile title='Follow Up Tasks' />,
    },
  ];

  const contactCards = [
    { name: 'Phone', value: profile?.data?.phone || '123-456-7890' },
    { name: 'Email', value: profile?.data?.email || '@example.com' },
    {
      name: 'Address',
      value: String(profile?.data?.address) || '123 Main St, City, Country',
    },
  ];

  const personalCards = [
    { name: 'Birth Date', value: profile?.data?.birthdate || 'N/A' },
    { name: 'Gender', value: profile?.data?.gender || 'N/A' },
    {
      name: 'Occupation',
      value: 'Engineer',
    },
  ];

  const householdCards = [
    { name: 'Marital Status', value: profile?.data?.birthdate || '05-19-1993' },
    { name: 'Spouse Name', value: 'Emma Cooper' },
    {
      name: 'Family Role',
      value: 'Father',
    },
    {
      name: 'Number of Children',
      value: '1',
    },
  ];

  const anniversaryCards = [
    { name: 'Wedding Anniversary', value: 'June 6, 2015' },
    { name: 'Baptism', value: 'March 2, 2020' },
  ];

  const memberStatusCards = [
    { name: 'Join Date', value: 'Jan 15, 2018' },
    { name: 'Status', value: 'Active' },
  ];

  const sheepfoldCards = [
    { name: 'Lay Pastor(s)', value: 'Sam & Suzy' },
    { name: 'Lay Leader(s)', value: 'Mike & Michelle' },
  ];

  const milestoneCards = [
    { name: 'Next Steps 1, 2, 3, 4', value: 'Sam & Suzy' },
    { name: 'SOL 1', value: 'Complete' },
    { name: 'SOL 2', value: 'Complete' },
  ];

  const tagCards = [
    { name: 'Group Leader', value: 'Group Leader' },
    { name: 'Royal Kids', value: 'Royal Kids' },
    { name: 'Worship', value: 'Worship' },
    { name: 'Kingdom Builder', value: 'Kingdom Builder' },
  ];

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!person) {
    return <div>Person not found</div>;
  }

  return (
    <>
      <Breadcrumb items={items} />
      <div className='mx-auto flex max-w-screen-xl flex-col justify-center gap-8'>
        <ProfileAvatarCard profileData={profile?.data} />
        <ProfileTabs tabs={tabs} />
        <CardContainer title='Contact' categories={contactCards} />
        <CardContainer title='Personal' categories={personalCards} />
        <CardContainer title='Household' categories={householdCards} />
        <CardContainer title='Anniversaries' categories={anniversaryCards} />
        <CardContainer title='Member Status' categories={memberStatusCards} />
        <CardContainer title='Sheepfold' categories={sheepfoldCards} />
        <CardContainer title='Milestones' categories={milestoneCards} />
        <CardContainer title='Tags' categories={tagCards} />
      </div>
    </>
  );
}
